import {TranslationKey} from '@enums'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import {Button} from '@mui/material'

import React from 'react'

import {t} from 'i18next'
import Dropzone from 'react-dropzone'

interface Props {
  disabled?: boolean
  handleDrop: (acceptedFiles: File[]) => void
}

/**
 * Dropzone component
 */
export function ButtonDropzone(props: Props) {
  const {handleDrop, disabled} = props

  return (
    <Dropzone disabled={disabled} onDrop={handleDrop} accept={{'application/pdf': []}}>
      {({getRootProps, getInputProps}) => (
        <section style={{}}>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <Button
              disabled={disabled}
              variant="contained"
              endIcon={<DocumentScannerIcon />}
              style={{margin: '0.44rem'}}
            >
              {t(TranslationKey['Upload document'])}
            </Button>
          </div>
        </section>
      )}
    </Dropzone>
  )
}
